import { getConditionsFilterConfig } from '../filters/condition';
import { getBrandDirectFilterConfig } from '../filters/brandDirect';
import { getGenderFilterConfig } from '../filters/gender';
import { getSizeFilterConfig } from '../filters/size';
import { getDefaultShopConfig } from './default';
import * as custom from '../filters/marketplace-custom-config';
import { BuilderSections } from '../../util/builder';

export const southerntideSizes = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', '1SZ'];

export const southerntideShopConfig = {
  ...getDefaultShopConfig(),
  filters: [
    ...custom.filters,
    getBrandDirectFilterConfig(),
    getConditionsFilterConfig(),
    getGenderFilterConfig(),
    getSizeFilterConfig({ sizes: southerntideSizes }),
  ],
  builderConfig: {
    sections: {
      [BuilderSections.LandingPageContent]: '041e9359064a4f9eb42715f470d694f5',
    },
  },
  homepageCategories: [
    {
      searchQuery: '?pub_category=men&mode=filter-change',
      label: 'Men',
    },
    {
      searchQuery: '?pub_category=women&mode=filter-change',
      label: 'Women',
    },
    {
      searchQuery: '?pub_category=kids&mode=filter-change',
      label: 'Kids',
    },
  ],
};
